import React from "react";
import { Icon } from "@iconify/react";
import UploadFile from "./DropZone";

const ImageUpload = ({ onUpload }) => {
  return (
    <>
      <UploadFile onUpload={onUpload} />
      
    </>
  );
};

export default ImageUpload;
